import { contentScrolledToTop, showAlert } from 'actions/client';
import { clearError } from 'actions/error';
import NotFound from 'components/NotFound';
import React from 'react';
import Pusher from 'react-pusher';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { queryAuthorizedVenues } from '../../actions/venue';
import { hasVenueSetupBeenCompleted } from '../../utils/venue/venue';
import './index.scss';
import MegaNav from './MegaNav';
import BookingsContainer from './Panels/Bookings';
import ClientPanel from './Panels/Client/index';
import CompletedBookingsPanel from './Panels/CompletedBookings';
import CreateVenuePanel from './Panels/CreateVenue';
import Financial from './Panels/Financial';
import LiveBookingsPanel from './Panels/LiveBookings';
import LogoutPanel from './Panels/Logout';
import MarketingPanel from './Panels/Marketing';
import MenuEditor from './Panels/MenuEditor';
import MultiVenue from './Panels/MultiVenue';
import SalesPanel from './Panels/Sales';
import SettingsPanel from './Panels/Settings';
import SetupPanel from './Panels/Setup/index';
import ViewUsersPanel from './Panels/Users/ViewUsersPanel';
import PermissionMessage from './PermissionMessage';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.contentContainerRef = React.createRef();
    this.state = { loading: false };
  }

  clearError() {
    this.props.clearError();
    window.location.reload();
  }

  componentWillMount() {
    this.props.contentScrolledToTop();
  }

  componentWillUpdate(nextProps, nextState) {
    if (
      !this.props.requestScroll &&
      nextProps.requestScroll &&
      !this.isScrolledToTop()
    ) {
      this.scrollContentToTop();
      this.props.contentScrolledToTop();
    } else if (
      !this.props.requestScroll &&
      nextProps.requestScroll &&
      this.isScrolledToTop()
    ) {
      this.props.contentScrolledToTop();
    }
  }

  render() {
    const path = this.props.match.path;
    const error = this.props.error.message;
    const { venue } = this.props;

    if (!this.props.token) {
      return <Redirect to="/auth/login" push />;
    }

    if (this.props.token && !this.props.hasVenues) {
      return <Redirect to="/auth/create-venue" push />;
    }

    let initialRedirect = { from: path, to: `${path}/live/`, exact: true };

    if (
      hasVenueSetupBeenCompleted(venue) &&
      !localStorage.getItem('hasShownSetup')
    ) {
      initialRedirect = { from: path, to: `${path}/live/`, exact: false };
      localStorage.setItem('hasShownSetup', 'true');
    } else if (
      !hasVenueSetupBeenCompleted(venue) &&
      !localStorage.getItem('hasShownSetup')
    ) {
      initialRedirect = { from: path, to: `${path}/setup/`, exact: false };
      localStorage.setItem('hasShownSetup', 'true');
    }

    const hasPermissions =
      this.props.permissions && this.props.permissions.length > 0;

    return (
      <div>
        <MegaNav hasPermissions={this.hasPermissions} />
        {!hasPermissions && this.state.loading ? (
          <PermissionMessage />
        ) : (
          <div className="content__container" ref={this.contentContainerRef}>
            {error ? (
              <div className="error__banner">
                {`Error: ${error}. `} <br />
                <button onClick={() => this.clearError()}>Reload?</button>
              </div>
            ) : null}

            <ConnectedRouter history={this.props.history}>
              <Switch>
                <Redirect {...initialRedirect} />
                <Route exact path={`${path}/setup/`} component={SetupPanel} />
                <Route
                  exact
                  path={`${path}/live/`}
                  component={LiveBookingsPanel}
                />
                <Route
                  exact
                  path={`${path}/completed/`}
                  component={CompletedBookingsPanel}
                />
                <Route exact path={`${path}/sales`} component={SalesPanel} />

                <Route
                  exact
                  path={`${path}/bookings/`}
                  component={BookingsContainer}
                />
                <Route
                  exact
                  path={`${path}/users/`}
                  component={ViewUsersPanel}
                />

                {/* <Route
      exact
      path={`${path}/assign/`}
      component={AssignManagerPanel}
    /> */}

                <Route
                  exact
                  path={`${path}/marketing`}
                  component={MarketingPanel}
                />

                <Route
                  exact
                  path={`${path}/multi-venue`}
                  component={MultiVenue}
                />

                <Route exact path={`${path}/clients`} component={ClientPanel} />

                <Route exact path={`${path}/menus`} component={MenuEditor} />

                <Route path={`${path}/financial`} component={Financial} />

                <Route
                  exact
                  path={`${path}/settings/`}
                  component={SettingsPanel}
                />

                <Route
                  exact
                  path={`${path}/create-venue`}
                  component={CreateVenuePanel}
                />

                <Route exact path={`${path}/logout`} component={LogoutPanel} />
                <Route component={NotFound} />
              </Switch>
            </ConnectedRouter>
          </div>
        )}

        <Pusher
          channel={`platform-updates`}
          event="platform-updated"
          onUpdate={this.platformUpdated}
        />
      </div>
    );
  }

  platformUpdated = data => {
    if (data.message) {
      this.props.showAlert('We have updated your platform.', data.message, () =>
        window.location.reload(true)
      );
    } else {
      window.location.reload(true);
    }
  };

  scrollContentToTop = () => {
    if (this.contentContainerRef !== undefined) {
      const node = this.contentContainerRef.current;

      if (node !== null) {
        node.scrollTop = 0;
      }
    }
  };

  isScrolledToTop = () => {
    if (this.contentContainerRef !== undefined) {
      const node = this.contentContainerRef.current;

      if (node !== null) {
        return node.scrollTop === 0;
      }
    }

    return true;
  };
}

const mapStateToProps = state => {
  const { role } = state.authentication;

  return {
    loading: state.authentication.loading,
    permissions: state.authentication.permissions,
    requestScroll: state.client.requestScroll,
    targetScrollPosition: state.client.targetScrollPosition,
    token: state.authentication.accessToken,
    error: state.error,
    venue: state.venue,
    hasVenues: state.authentication.hasVenues,
    role: role,
  };
};

const mapDispatchToProps = dispatch => ({
  clearError: () => dispatch(clearError()),
  contentScrolledToTop: () => dispatch(contentScrolledToTop()),
  queryAuthorizedVenues: query => dispatch(queryAuthorizedVenues(query)),
  showAlert: (title, message, callback) =>
    dispatch(showAlert(title, message, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.jsx